import React from 'react';
import SpreadsheetBuilder from './SpreadsheetBuilder';
import './SpreadsheetDemo.css';

const SpreadsheetDemo = () => {
  return (
    <div className="spreadsheet-demo">
      <SpreadsheetBuilder />
    </div>
  );
};

export default SpreadsheetDemo;








